import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=8ebfa470&scoped=true&"
import script from "./Captcha.vue?vue&type=script&lang=js&"
export * from "./Captcha.vue?vue&type=script&lang=js&"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=8ebfa470&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebfa470",
  null
  
)

export default component.exports